export default __webpack_public_path__ + "static/media/portfolio-216.ac06629e.jpg";